import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import DataDrivenLogo from '../../../components/data-driven-logo';
import GetFulfillmentProviderDisplayName from '../../../components/data-driven-logo/get-fulfillment-provider-display-name';
import GetProviderDisplayName from '../../../components/data-driven-logo/get-provider-display-name';
import FormattedCurrencyContainer from '../../../components/formatted-currency/container';
import { StampsWalletDHLService } from '../../../services/stamps-wallet-dhl-service';
import style from './cost-review-line-item-header.module.less';

const getDisplayName = (providerId, fulfillmentProviderId, walletDisplayName) => {
  if (walletDisplayName) {
    return walletDisplayName;
  }
  if (fulfillmentProviderId) {
    return GetFulfillmentProviderDisplayName(fulfillmentProviderId);
  }
  if (StampsWalletDHLService.isStampsDhlProvider(providerId)) {
    return StampsWalletDHLService.getStampsDhlProviderDisplayInformation().displayName;
  }
  return GetProviderDisplayName(providerId);
};

const CostReviewLineItemHeader = ({
  nickname,
  balance = 0.0,
  showBalance = false,
  balanceCurrencyCode = null,
  providerId = '',
  fulfillmentProviderId,
  walletDisplayName,
}) => {
  const isWallet = !!walletDisplayName;
  const isFulfillmentProvider = !!fulfillmentProviderId;
  const rawDisplayName = getDisplayName(providerId, fulfillmentProviderId, walletDisplayName);
  const displayName = typeof rawDisplayName === 'string' ? rawDisplayName : <FormattedMessage {...rawDisplayName} />;

  return (
    <div className={style.header}>
      {!isWallet && (
        <div
          className={classnames(style['provider-logo'], {
            [style['stamps-dhl-provider']]: isWallet,
          })}
        >
          {!isFulfillmentProvider && <DataDrivenLogo logoType='icon' providerId={providerId} />}
          {isFulfillmentProvider && <DataDrivenLogo fillProviderId={fulfillmentProviderId} />}
        </div>
      )}
      <div className={classnames(style['provider-details'])}>
        <div
          className={classnames(style['provider-name'], {
            [style['no-balance']]: !showBalance,
          })}
        >
          {displayName}
          {nickname && `: ${nickname}`}
        </div>
        {showBalance && (
          <div className={style['provider-balance']}>
            <FormattedCurrencyContainer currencyCode={balanceCurrencyCode} value={balance}>
              {(formattedBalance) => (
                <FormattedMessage
                  defaultMessage='Current Balance:<s>{formattedBalance}</s>'
                  description='costReviewLineItemHeader.balance'
                  id='4xjdcK'
                  values={{
                    formattedBalance,
                    s: (chunks) => <span className={style['provider-balance-amount']}>{chunks}</span>,
                  }}
                />
              )}
            </FormattedCurrencyContainer>
          </div>
        )}
      </div>
    </div>
  );
};

CostReviewLineItemHeader.propTypes = {
  balance: PropTypes.number,
  balanceCurrencyCode: PropTypes.string,
  showBalance: PropTypes.bool,
  nickname: PropTypes.string,
  providerId: PropTypes.string,
  fulfillmentProviderId: PropTypes.number,
  walletDisplayName: PropTypes.string,
};

export default CostReviewLineItemHeader;
